import windowRoot from 'window-or-global';
import { useState, useEffect } from 'preact/hooks';
import { useThrottleFn } from 'ahooks';

interface IProps {
  wait?: number;
}

const useWindowSize = (props: IProps) => {
  const wait = props.wait ?? 0;
  const [windowSize, setWindowSize] = useState<{
    width?: number;
    height?: number;
  }>({
    width: undefined,
    height: undefined,
  });

  const { run: handleResize } = useThrottleFn(
    () => {
      if (typeof window === 'undefined') {
        setWindowSize({ width: 0, height: 0 });
      } else {
        setWindowSize({
          width: windowRoot.innerWidth,
          height: windowRoot.innerHeight,
        });
      }
    },
    { wait }
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    windowRoot.addEventListener('resize', handleResize);

    handleResize();

    return () => windowRoot.removeEventListener('resize', handleResize);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return windowSize;
};

export default useWindowSize;
